(function ($) {

    var $message;

    function formBeforeSubmit($form) {
        $form.closest('.loader').addClass('is-active');
        $form.find(':submit').prop('disabled', true);
        $message && $message.trigger('message-dismiss');
    }

    function formAfterSubmit($form) {
        $form.closest('.loader').removeClass('is-active');
        $form.find(':submit').prop('disabled', false);
    }

    function requestInfoOnSubmit(event) {
        var $form = $(this);

        function done(response) {
            // $form.trigger('reset');

            $message && $message.trigger('message-dismiss');
            $message = CHWEB.message($form.data('request-info-message'), 'message', 0, 'modal');
            $message.one('message-dismissed', scrollToTop);

            console.log(response);
        }

        function fail(response) {
            var message = (response.responseJSON && response.responseJSON[Object.keys(response.responseJSON)[0]]) || $form.data('request-info-error');

            $message && $message.trigger('message-dismiss');
            $message = CHWEB.message(message, 'error', 0, 'modal');
        }

        function always () {
            formAfterSubmit($form);
        }

        function scrollToTop () {
            UTIL.scrollto('body', true);
        }


        event.preventDefault();

        formBeforeSubmit($form);

        function submitForm() {
            $.post($form.attr('action'), $form.serialize())
                .done(done)
                .fail(fail)
                .always(always);
        }

        // Get Enterprise token if available
        function getTokenAndSubmit() {
            if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise && window.RECAPTCHA_SITE_KEY) {
                grecaptcha.enterprise.ready(async function() {
                    try {
                        const token = await grecaptcha.enterprise.execute(window.RECAPTCHA_SITE_KEY, {action: 'submit'});
                        $form.find('input[name="g-recaptcha-response"]').val(token);
                        submitForm();
                    } catch (error) {
                        console.error('reCAPTCHA error:', error);
                        submitForm();
                    }
                });
            } else if (window.RECAPTCHA_SITE_KEY) {
                // Wait for reCAPTCHA to load (max 5 seconds)
                var attempts = 0;
                var checkInterval = setInterval(function() {
                    attempts++;
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
                        clearInterval(checkInterval);
                        getTokenAndSubmit();
                    } else if (attempts >= 50) {
                        clearInterval(checkInterval);
                        console.warn('reCAPTCHA failed to load, submitting without token');
                        submitForm();
                    }
                }, 100);
            } else {
                submitForm();
            }
        }
        
        getTokenAndSubmit();
    }


    $(document).on('submit.request-info', '[data-request-info]', requestInfoOnSubmit);

}(jQuery));
